export default __webpack_public_path__ + "static/media/shawnipedia.833f31f2.png";